import React, { useEffect, useState } from "react";

import { layout } from "../models/LayoutProductCatalog";
import { useSignal } from "@preact/signals-react";
import Button from "componentsv2/button/Button";
import { ArcheryIcon, TimeIcon } from "components/Icons";
import { useTable } from "storev2/tableStore";
import LayoutView from "../layouts/LayoutView";
import Board from "componentsv2/board/Board";

const layoutShift = layout();

const MainCatalog = () => {
  const currentView = useSignal("list");
  const { setTable } = useTable();
  const [activeTab, setActiveTab] = useState("activas");

  useEffect(() => {
    setTable({ layout: layoutShift });
  }, []);

  function handleTabChange(tab) {
    setActiveTab(tab);
    setRecords(tab === "cards" ? historyRecords : []);
  }

  function getButtonStyles(isActive) {
    return {
      button: `rounded-t-xl rounded-b-none border-none transition-colors duration-200 ${
        isActive
          ? "!bg-[#1f2937FF] text-white"
          : "!bg-transparent text-[#1f2937FF] hover:!bg-[#1f2937FF] hover:text-white"
      }`,
      icon: `w-6 h-6 fill-current transition-colors duration-200 ${
        isActive ? "text-white" : "text-[#1f2937FF] group-hover:text-white"
      }`,
    };
  }

  function handleRecordId(recordId) {
    console.log("recordId", recordId);
  }

  return (
    <LayoutView title={"Catalogo de productos"} link={"staff_supply"}>
      <div className="border-b border-[#1f2937FF]/30 w-full mt-4 flex justify-between">
        <div className="flex top-[1px] relative w-[400px]">
          {(() => {
            const { button, icon } = getButtonStyles(activeTab === "activas");
            return (
              <Button
                content="Lista"
                style={button}
                iconLeft={<ArcheryIcon className={icon} />}
                size="w-full"
                onClick={() => handleTabChange("activas")}
              />
            );
          })()}

          {(() => {
            const { button, icon } = getButtonStyles(activeTab === "historial");
            return (
              <Button
                content="Tarjetas"
                style={`w-full ${button} group`}
                iconLeft={<TimeIcon className={icon} />}
                size="w-full"
                onClick={() => handleTabChange("historial")}
              />
            );
          })()}
        </div>

        <div className="-mt-3 flex flex-col justify-end"></div>
      </div>
      {/* data */}
      <Board
        layout={layoutShift}
        handleRecordId={handleRecordId}
        currentView={currentView}
      />
    </LayoutView>
  );
};

export default MainCatalog;
